import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { schematicStore } from "../stores/schematic";
import { tabsStore } from "../stores/tabs";
import { storeUtils } from "./util";
const { ActionTypes } = Constants;
const _events = new storeUtils.EventEmitter();

var _messages = []; //a messages looks like {field:'field_name', message: 'the displayed message', type: 'error or info'}

var dispatchToken = dispatcher.register(function (action) {
  var _schematicError = [];
  switch (action.type) {
    //Get the errors of the form store
    case ActionTypes.UPDATED_FORM_B_RESTRICTION:
    case ActionTypes.SELECT_CHANGED:
    case ActionTypes.TRACK_SELECTION_CHANGED:
    case ActionTypes.RESET_FORM_B_RESTRICTION:

    case ActionTypes.SUBMIT_FORM_B_RESTRICTION:
    case ActionTypes.DATE_FORM_FIELD_VALID:
    case ActionTypes.FORM_FIELD_INVALID:
    case ActionTypes.FORM_FIELD_VALID:
    case ActionTypes.FORM_FIELD_BLURRED:
    case ActionTypes.VALIDATE_FORM_B_RESTRICTION:
    case ActionTypes.SCHEMATIC_UPDATE_COMPLETE:
    case ActionTypes.SERVER_GUID_ERROR:
    case ActionTypes.FORM_C_SUBDIVISION_SELECTED:
    case ActionTypes.CHANGED_SELECT_ENTIRE_SUB:
      //case ActionTypes.BATCH_SUBMIT_SUCCESSFUL:
      //wait for formb store to update its form errors
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      dispatcher.waitFor([schematicStore.dispatchToken]);
      _messages = restrictionRequestStore.getDisplayErrors();
      var _schematicError = schematicStore.getErrors();
      if (_schematicError.length > 0) _messages.push(_schematicError[0]);
      _events.trigger(Constants.ActionTypes.CHANGE_EVENT);
      break;
    //These cases throw a special error if the form can not be opened
    case ActionTypes.OPEN_FORM_B_RESTRICTION:
    case ActionTypes.OPEN_FORM_A_RESTRICTION:
    case ActionTypes.OPEN_FORM_A_REQUEST:
    case ActionTypes.OPEN_FORM_B_REQUEST:
      if (action.form) {
        //wait for formb store to update its form errors
        dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
        dispatcher.waitFor([schematicStore.dispatchToken]);
        _messages = restrictionRequestStore.getDisplayErrors();
        _schematicError = schematicStore.getErrors();
        if (_schematicError.length > 0) _messages.push(_schematicError[0]);
        //console.log('_messages', _messages);
      } else {
        //If the form is null something went wrong with the conversion so show the conversion error
        _messages = [];
        _messages.push(action.errorMessage);
      }
      _events.trigger(Constants.ActionTypes.CHANGE_EVENT);
      break;

    //get the error from the action
    case ActionTypes.TERRITORY_DETAIL_FAILED_LOAD:
    case ActionTypes.SUBMIT_TO_SERVER_FAILED:
    case ActionTypes.SUBMIT_TO_SERVER_404_500:
    case ActionTypes.SERVER_ACTION_FAILED:
    case ActionTypes.POLL_SUCCESSFUL:
    case ActionTypes.REMOVE_POLL_ID:
    case ActionTypes.MF_ERROR_RETURNED:
    case ActionTypes.SCHEMATIC_SUB_FAILED_LOAD:
    case ActionTypes.LIST_FAILED_LOADING:
    case ActionTypes.AUTHENTICATION_FAILED:
      if (action.message) {
        _messages = action.message;
        _events.trigger(Constants.ActionTypes.CHANGE_EVENT);
      }
      break;

    //clear all errors
    case ActionTypes.USER_CHANGED:
    case ActionTypes.TERRITORY_CHANGED:
    case ActionTypes.SCHEMATIC_SUB_LOADED:
      _messages = [];
      _events.trigger(Constants.ActionTypes.CHANGE_EVENT);
      break;

    case ActionTypes.TAB_CHANGED:
      dispatcher.waitFor([tabsStore.dispatchToken]);
      if (!tabsStore.inBatchMode()) {
        if (action.tabChanged == "form") {
          _messages = [];
          _events.trigger(Constants.ActionTypes.CHANGE_EVENT);
        }
      }
      break;

    default:
    // no-op
  }
});

export const informationRadiatorStore = {
  dispatchToken,
  getMessages: function () {
    return _messages;
  },
  subscribe: _events.on,
  unsubscribe: _events.off,
};
